import React, { Component, Fragment } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { FormatCurrency } from "../currencyFormatter";
import {
  AUTHORIZATION_APPROVED,
  AUTHORIZATION_EXPIRED,
  AUTHORIZATION_PENDING,
} from "../../../store/types";
import { FileCopyOutlined, Replay } from "@material-ui/icons";
import {
  reInitiateTransaction,
  showPurchaseConfirmation,
  getInvestorDetails,
  addToCart,
  reinitate,
} from "../../../store/actions";
import ReinitiateConfirm from "../transactions/ReinitiateConfirm";
import { Dialog } from "@material-ui/core";
import TableAction from "./TableAction";
import DashboardTableResponsive from "./TableResponsive";
import { convertToInr } from "../../../utils/cart";

class TableContainer extends Component {
  async copyTransactionLink(transaction) {
    if (!!transaction.Link) {
      const link = transaction.Link || "";
      await navigator.clipboard.writeText(link);
      alert("Link copied to clipboard!");
    } else {
      alert("Failed to copy the link");
    }
  }
  constructor(props) {
    super(props);
    this.state = {
      transaction: null,
      isLoading: false,
    };
  }

  handleReInitiate(item) {
    // this.setState({ transaction: item })
    this.props.history.push({
      pathname: `/dashboard/re-initiate-transaction`,
      state: { transaction: item },
    });
  }

  modifyTranscation = async (item) => {
    this.setState({
      isLoading: true,
    });
    const params = {
      Uid: this.props.userId,
      ReqBy: "a",
      PAN: item.pan,
    };
    await this.props.getInvestorDetails(params);
    if (!!item && item.trtype === "New Purchase") {
      this.props.history.push({
        pathname: "/new-transaction/nfo-new-purchase/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    if (!!item && item.trtype === "Purchase") {
      this.props.history.push({
        pathname: "/new-transaction/additional-purchase/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    if (!!item && item.trtype === "SIP") {
      this.props.history.push({
        pathname: "/new-transaction/sip/digital/transact",
        state: { transaction: item, Pan: item.pan },
      });
    }
    if (!!item && item.trtype === "Switch") {
      this.props.history.push({
        pathname: "/new-transaction/switch/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    if (!!item && item.trtype === "Redemption") {
      this.props.history.push({
        pathname: "/new-transaction/redemption/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    if (!!item && item.trtype === "STP") {
      this.props.history.push({
        pathname: "/new-transaction/stp/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    if (!!item && item.trtype === "SWP") {
      this.props.history.push({
        pathname: "/new-transaction/swp/digital/transact",
        state: { transaction: item, pan: item.pan },
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  async addToCart(item) {
    try {
      if (item.orders.length) {
        const response = await this.props.addToCart({
          orderIds: item.orders.map((order) => order.orderId),
          ihno: "",
        });
        this.props.history.push({
          pathname: "/cart/investor-cart",
          state: { pan: response.pan },
        });
        return;
      }
      const response = await this.props.addToCart({
        orderIds: [],
        ihno: item.dco_ihno,
      });
      this.props.history.push({
        pathname: "/cart/investor-cart",
        pan: response.pan,
      });
      return;
    } catch (error) {
      alert(error);
    }
  }

  async copyCartLink(item) {
    try {
      const link = item.orders[0].link;
      await navigator.clipboard.writeText(link);
      alert("Link copied to clipboard!");
    } catch (error) {
      alert("Failed to copy the link");
    }
  }

  async reinitiate(order) {
    try {
      const response = await this.props.reinitate(String(order.dco_ihno));
      if (response) {
        alert("Transaction Reinitiated Successfully");
        return;
      }
    } catch (error) {
      alert(error);
    }
  }
  convertToCSV = (objArray) => {
    const header = [
      "Name",
      "Mobile",
      "Transaction Type",
      "Date",
      "Reference Number",
      "Amount",
      "Units"
    ];
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString('en-GB', { hour12: false });
    };
    const csvData = objArray.map(item => ({
      Name: item?.dco_inv_name,
      Mobile: item?.dco_inv_mobile,
      "Transaction Type": item?.investment_type,
      Date: formatDate(item?.dco_updated_at),
      "Reference Number": item?.dco_ihno,
      Amount: item?.amount,
      Units: item?.units
    }));

    const csvArray = [header].concat(csvData.map(row => Object.values(row).map(value => `"${value}"`)));

    return csvArray.map(row => row.join(",")).join("\n");
  };
  Download = () => {
    const { transactionHistory } = this.props;
    const orders = transactionHistory.map((ele) => ele.orders[0])
    const csv = this.convertToCSV(orders);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", this.props.active === AUTHORIZATION_PENDING ? "AUTHORIZATION PENDING.csv" : this.props.active === AUTHORIZATION_EXPIRED ? "AUTHORIZATION EXPIRED.csv" : "AUTHORIZATION APPROVED.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const { transactionHistory } = this.props;
    const active = this.props.active;
    // const allowCopy = this.props.active != AUTHORIZATION_EXPIRED
    const transaction = this.state.transaction;

    const isPending = active === AUTHORIZATION_PENDING;
    if (!transactionHistory.length) {
      return <div className="text-center p-4">No Data Found</div>;
    }
    return (
      <React.Fragment>
        {transactionHistory.length > 0 && (
          <div style={{display:"flex",justifyContent:"end"}}>
          <button
            className="download-button new-investor-active"
            onClick={this.Download}
          >
            Download in Excel format
          </button>
          </div>
        )}
        <Paper className="trasaction-summary-responsive">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: 5,
            }}
          />
          <Table>
            <TableHeader />
            <TableBody>
              {transactionHistory.map((item, index) => {
                const isCart = Boolean(item.dco_cart_id);

                return (
                  <React.Fragment key={index}>
                    {item.orders.map((order, orderIndex) => (
                      <TableRow key={orderIndex}>
                        {orderIndex === 0 ? (
                          <>
                            <TableCell
                              style={{
                                padding: "30px 10px 30px 10px",
                                color: "#2f3953",
                                fontSize: 15,
                                fontFamily: "OpenSans-Regular",
                              }}
                              rowSpan={item.orders.length}
                            >
                              {item.orders[0].dco_inv_name || "-"}
                            </TableCell>

                            <TableCell
                              style={{
                                padding: "30px 10px  30px 10px",
                                color: "#2f3953",
                                fontSize: 15,
                                fontFamily: "OpenSans-Regular",
                              }}
                              rowSpan={item.orders.length}
                            >
                              {item.orders[0].dco_inv_mobile || "NA"}
                            </TableCell>

                            <TableCell
                              style={{
                                padding: "30px 10px 30px 10px",
                                color: "#2f3953",
                                fontSize: 15,
                                fontFamily: "OpenSans-Regular",
                              }}
                              rowSpan={item.orders.length}
                            >
                              {item.orders[0].investment_type}
                            </TableCell>
                            <TableCell
                              style={{
                                padding: "30px 10px 30px 10px",
                                color: "#2f3953",
                                fontSize: 15,
                                fontFamily: "OpenSans-Regular",
                              }}
                              rowSpan={item.orders.length}
                            >
                              {item.dco_updated_at}
                            </TableCell>
                          </>
                        ) : null}

                        <TableCell
                          key={order.dco_ihno}
                          style={{
                            padding: "30px 10px 30px 10px ",
                            color: "#2f3953",
                            fontSize: 15,
                            fontFamily: "OpenSans-Regular",
                          }}
                        >
                          {order.scheme}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "30px 10px 30px 10px",
                            color: "#2f3953",
                            fontSize: 15,
                            fontFamily: "OpenSans-SemiBold",
                          }}
                        >
                          {order.dco_ihno || "NA"}
                        </TableCell>

                        <AmountTableCell
                          units={order.units}
                          amount={order.amount}
                          sipamount={order.sipamount}
                        />

                        <TableAction
                          isPending={isPending}
                          isDotNet={item.isDotNet}
                          order={order}
                          isCart={isCart}
                          orderIndex={orderIndex}
                          length={item.orders.length}
                          item={item}
                        />
                      </TableRow>
                    ))}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
        <div className="mobile-aum-list">
          <DashboardTableResponsive isPending={isPending} />
        </div>

        <Dialog
          open={!!this.state.transaction}
          onClose={() => this.setState({ transaction: null })}
          PaperProps={{
            style: {
              width: "80vw",
            },
          }}
        >
          <div className="p-4">
            {!!transaction && (
              <ReinitiateConfirm
                standalone={false}
                transaction={transaction}
                onClose={() => this.setState({ transaction: null })}
                onConfirm={() => {
                  this.handleReInitiateTransaction(this.state.transaction);
                }}
              />
            )}
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ dashboard, loading, authReducer, cartReducer }) => {
    const { beta_user, userId } = authReducer;
    const { summaryData = [] } = dashboard;
    const { transactionHistory } = cartReducer;
    const { count } = loading;
    return {
      summaryData,
      isLoading: count > 0,
      beta_user,
      userId,
      transactionHistory,
    };
  },
  {
    reInitiateTransaction,
    showPurchaseConfirmation,
    getInvestorDetails,
    addToCart,
    reinitate,
  }
)(TableContainer);
export class InvestorTableCard extends Component {
  render() {
    const active = this.props.active;
    const showReinitiate = [
      AUTHORIZATION_EXPIRED,
      AUTHORIZATION_APPROVED,
    ].includes(active);
    const showCopyButton = [AUTHORIZATION_PENDING].includes(active);
    const item = this.props.item;

    const {
      InvName,
      mobile,
      scheme,
      sipamount,
      amount,
      Entdate,
      trtype,
      dd_appno,
    } = item;

    return (
      <div
        style={{
          background: "white",
          border: "1px solid rgba(211,211,211,0.3)",
          padding: "7px 10px",
          margin: "10px 0px",
        }}
      >
        <div
          style={{
            fontFamily: "SourceSansPro-SemiBold",
            color: "#00579b",
            fontSize: 14,
            paddingBottom: 5,
            borderBottom: "1px solid rgba(211,211,211,0.3)",
          }}
        >
          {scheme}
        </div>

        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}>
              Name
            </div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 13,
                color: "#293139",
              }}
            >
              {!!InvName ? InvName : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}>
              Date
            </div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 13,
                color: "#293139",
              }}
            >
              {!!Entdate ? Entdate : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}>
              Type
            </div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 13,
                color: "#293139",
              }}
            >
              {!!trtype ? trtype : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}>
              Contact
            </div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 13,
                color: "#293139",
              }}
            >
              {!!mobile ? mobile : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}>
              Amount/Units
            </div>
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 13,
                color: "#293139",
              }}
            >
              {!!item.sipamount || !!item.amount ? (
                <FormatCurrency
                  value={
                    item.trtype === "SIP"
                      ? !!item.sipamount
                        ? item.sipamount
                        : ""
                      : !!item.amount
                      ? item.amount
                      : ""
                  }
                />
              ) : (
                0
              )}
              /{!!item.units ? item.units : 0}
            </div>
          </div>
          {this.props.active != AUTHORIZATION_EXPIRED && (
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{ fontFamily: "SourceSansPro-Regular", fontSize: 12 }}
              >
                Reference No
              </div>
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 13,
                  color: "#293139",
                }}
              >
                {!!dd_appno ? dd_appno : "NA"}
              </div>
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexBasis: 0,
            display: "flex",
            marginBottom: "4px",
            border: "none",
            padding: "12px 4px",
          }}
          className={`MuiTableCell-root table-cell`}
        >
          {!!showCopyButton && (
            <div
              className="transaction-button mouse-pointer d-flex align-items-center mr-1"
              onClick={() => this.props.onCopy(item)}
            >
              <FileCopyOutlined style={{}} className="d-block d-xl-none m-0" />
              <p
                className="d-none d-xl-block m-0"
                style={{ whiteSpace: "nowrap" }}
              >
                Copy link
              </p>
            </div>
          )}
          {!!showReinitiate &&
            (item.trtype === "Redemption" ||
              item.trtype === "Switch" ||
              item.trtype === "Purchase" ||
              item.trtype === "New Purchase" ||
              item.trtype === "SIP Cancellation" ||
              item.trtype === "SIP Pause") && (
              <div
                className="transaction-button d-flex align-items-center mouse-pointer"
                onClick={() => this.props.onReInitiate(item)}
              >
                {" "}
                <Replay className="d-block d-xl-none m-0" />
                <p
                  className="d-none d-xl-block m-0"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Re-initiate
                </p>
              </div>
            )}
        </div>
      </div>
    );
  }
}

const AmountTableCell = ({ units, amount, sipamount }) => {
  if (units) {
    return (
      <TableCell
        style={{
          padding: "30px 10px 30px 10px",
          color: "#2f3953",
          fontSize: 15,
          fontFamily: "OpenSans-Regular",
        }}
      >{`U - ${units}`}</TableCell>
    );
  }

  if (amount && sipamount) {
    return (
      <Fragment>
        <TableCell
          style={{
            padding: "30px 10px 30px 10px",
            color: "#2f3953",
            fontSize: 15,
            fontFamily: "OpenSans-Regular",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {`${convertToInr(sipamount)}(SIP)`}
        </TableCell>
        <TableCell
          style={{
            padding: "30px 10px 30px 10px",
            color: "#2f3953",
            fontSize: 15,
            fontFamily: "OpenSans-Regular",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {`${convertToInr(amount)}(Lumpsum)`}
        </TableCell>
      </Fragment>
    );
  }

  if (sipamount) {
    return (
      <TableCell
        style={{
          padding: "30px 10px 30px 10px",
          color: "#2f3953",
          fontSize: 15,
          fontFamily: "OpenSans-Regular",
        }}
      >
        {`${convertToInr(sipamount)}(SIP)`}
      </TableCell>
    );
  }

  return (
    <TableCell
      style={{
        padding: "30px 10px 30px 10px",
        color: "#2f3953",
        fontSize: 15,
        fontFamily: "OpenSans-Regular",
      }}
    >
      {convertToInr(amount) || "-"}
    </TableCell>
  );
};

function TableHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          INVESTOR
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          CONTACT
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          TYPE
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          DATE
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          SCHEME
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          Ref No
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          AMOUNT/UNITS
        </TableCell>
        <TableCell
          style={{
            padding: "20px",
            color: "white",
            fontSize: 15,
            fontFamily: "OpenSans-SemiBold",
            backgroundColor: "#007ac8",
          }}
        >
          ACTION
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
